import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.9856 18.9855L2 2",
		stroke: "currentColor",
		strokeWidth: 3.22606,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2 18.9855L18.9856 2",
		stroke: "currentColor",
		strokeWidth: 3.22606,
		strokeLinecap: "round"
	})]
});
export default SvgCross;
